import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';
import { Icon } from '@iconify/react/dist/iconify.js';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DeleteConfirmModal = ({ open, handleClose, handleConfirm, vendor, isLoading }) => {
    if (!vendor) return null;

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle
                sx={{
                    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                    color: 'white',
                    position: 'relative',
                    overflow: 'hidden',
                    p: 3,
                }}
            >
                <svg
                    width="100%"
                    height="100%"
                    viewBox="0 0 400 300"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ position: 'absolute', top: 0, left: 0, opacity: 0.1 }}
                >
                    <circle cx="50" cy="50" r="40" fill="white" />
                    <circle cx="350" cy="250" r="60" fill="white" />
                    <circle cx="150" cy="200" r="30" fill="white" />
                </svg>
                <Box sx={{ position: 'relative', zIndex: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Delete Vendor
                    </Typography>
                </Box>
            </DialogTitle>

            <DialogContent sx={{ p: 3, backgroundColor: '#f8fafc', textAlign: 'center' }}>
                {/* Warning Icon */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        mb: 2,
                    }}
                >
                    <Avatar
                        sx={{
                            width: 72,
                            height: 72,
                            backgroundColor: 'rgba(239, 68, 68, 0.1)',
                            color: '#ef4444',
                        }}
                    >
                        <Icon icon="mingcute:delete-2-line" width={40} height={40} />
                    </Avatar>
                </Box>

                {/* Warning Message */}
                <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: '#1f2937', mb: 1 }}>
                    Are you sure you want to delete this vendor?
                </Typography>

                <Typography sx={{ fontSize: '0.875rem', color: '#6b7280', mb: 2 }}>
                    This action cannot be undone. All associated data will be permanently removed.
                </Typography>

                {/* Vendor Preview Card */}
                <Box sx={{ backgroundColor: 'white', p: 2, borderRadius: 1, mb: 3, textAlign: 'left' }}>
                    <Typography sx={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: 500, mb: 1 }}>
                        VENDOR TO DELETE
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <Avatar
                            sx={{
                                width: 48,
                                height: 48,
                                backgroundColor: '#ef4444',
                                color: 'white',
                                fontSize: '1.25rem',
                                fontWeight: 600,
                            }}
                        >
                            {vendor.name.charAt(0).toUpperCase()}
                        </Avatar>
                        <Box>
                            <Typography sx={{ fontSize: '0.9375rem', fontWeight: 600, color: '#1f2937' }}>
                                {vendor.name}
                            </Typography>
                            <Typography sx={{ fontSize: '0.8125rem', color: '#6b7280' }}>
                                {vendor.email}
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                {/* Confirmation Notice */}
                <Box
                    sx={{
                        backgroundColor: 'rgba(239, 68, 68, 0.1)',
                        p: 2,
                        borderRadius: 1,
                        border: '1px solid rgba(239, 68, 68, 0.3)',
                    }}
                >
                    <Typography sx={{ fontSize: '0.8125rem', color: '#b91c1c', fontWeight: 500 }}>
                        Please type the vendor name to confirm deletion.
                    </Typography>
                </Box>
            </DialogContent>

            <DialogActions sx={{ p: 2, gap: 1 }}>
                <Button
                    variant="outlined"
                    onClick={handleClose}
                    disabled={isLoading}
                    sx={{ textTransform: 'capitalize' }}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={handleConfirm}
                    disabled={isLoading}
                    sx={{
                        backgroundColor: '#ef4444',
                        '&:hover': {
                            backgroundColor: '#dc2626',
                        },
                        textTransform: 'capitalize',
                    }}
                >
                    {isLoading ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
                    Delete Vendor
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmModal;
